import * as React from 'react';
import useIntersectionObserver, {
    IntersectionObserverOptions,
} from '@react-hook/intersection-observer';

export default function useHasIntersected<T extends HTMLElement = HTMLElement>(
    target: T | React.RefObject<T> | null,
    options?: IntersectionObserverOptions,
): boolean {
    const { isIntersecting } = useIntersectionObserver(target, options);
    const [hasIntersected, setHasIntersected] = React.useState(isIntersecting);

    React.useEffect(() => {
        if (isIntersecting && !hasIntersected) {
            setHasIntersected(true);
        }
    }, [isIntersecting, hasIntersected]);

    return hasIntersected;
}
